export const addedValues = {
  ArchitectsAndEngineers: [
    'EfficientControl',
    'SignificantlyEasierClaimManagement',
    'OptimizationOfCooperation',
    'AccessProjectWithData',
    'TimeSavings',
  ],
  BimManagersAndProjectControllers: [
    'OptimizationOfCooperation',
    'TimeSavings',
    'EfficientControl',
    'AlwaysMaintainAnOverview',
    'AccessProjectWithData',
    'SignificantlyEasierClaimManagement',
  ],
  GeneralContractors: [
    'ReductionofAdditionalWork',
    'FasterResponseToProblems',
    'OptimizationOfCooperation',
    'TimeSavings',
    'EfficientControl',
    'KeepTrack',
    'AccessProjectWithData',
  ],
  BuildersAndProjectDevelopers: [
    'TimelyCompletion',
    'EverythingAtGlance',
    'TraceabilityOfActivities',
    'MoreEfficientCommunication',
    'RecognizingAndEliminating',
    'AccessProjectWithData',
  ],
};

export const workflowsInfo = {
  ArchitectsAndEngineers: {
    TaskAndIssueProcesses: 'TaskAndIssueProcessesDescription',
    RFIs: 'RFIsDescription',
    AutomaticSynchronizationOperations: 'AutomaticSynchronizationOperationsDescription',
    CoordinationProcesses: 'CoordinationProcessesDescription',
    CollisionManagement: 'CollisionManagementDescription',
    WorkflowTemplates: 'WorkflowTemplatesDescription',
    BuildingComponentAnalyses: 'BuildingComponentAnalysesDescription',
    options: [
      'TaskAndIssueProcesses',
      'RFIs',
      'AutomaticSynchronizationOperations',
      'CoordinationProcesses',
      'CollisionManagement',
      'WorkflowTemplates',
      'BuildingComponentAnalyses',
    ],
  },
  BimManagersAndProjectControllers: {
    CoordinationProcesses: 'CoordinationProcessesDescription',
    RFIs: 'RFIsDescription',
    WorkflowTemplates: 'WorkflowTemplatesDescription',
    ApprovalProcesses: 'ApprovalProcessesDescription',
    TaskAndIssueProcesses: 'TaskAndIssueProcessesDescription',
    DigitalConstructionFile: 'DigitalConstructionFileDescription',
    UserAndRoleManagement: 'UserAndRoleManagementDescription',
    options: [
      'CoordinationProcesses',
      'RFIs',
      'WorkflowTemplates',
      'ApprovalProcesses',
      'TaskAndIssueProcesses',
      'DigitalConstructionFile',
      'UserAndRoleManagement',
    ],
  },
  GeneralContractors: {
    IssueManagement: 'IssueManagementDescription',
    ConstructionDiary: 'ConstructionDiaryDescription',
    RFIs: 'RFIsDescription',
    DigitalConstructionFile: 'DigitalConstructionFileDescription',
    ApprovalProcesses: 'ApprovalProcessesDescription',
    ConstructionDocumentation: 'ConstructionDocumentationDescription',
    options: [
      'IssueManagement',
      'ConstructionDiary',
      'RFIs',
      'DigitalConstructionFile',
      'ApprovalProcesses',
      'ConstructionDocumentation',
    ],
  },
  BuildersAndProjectDevelopers: {
    TaskAndIssueProcesses: 'TaskAndIssueProcessesDescription',
    SupplementManagement: 'SupplementManagementDescription',
    RFIs: 'RFIsDescription',
    WorkflowTemplates: 'WorkflowTemplatesDescription',
    ApprovalProcesses: 'ApprovalProcessesDescription',
    options: [
      'TaskAndIssueProcesses',
      'SupplementManagement',
      'RFIs',
      'WorkflowTemplates',
      'ApprovalProcesses',
    ],
  },
};

export const sliderTitles = {
  BimManagersAndProjectControllers: [
    'BimManagersAndProjectControllersSliderTitle1',
    'BimManagersAndProjectControllersSliderTitle2',
    'BimManagersAndProjectControllersSliderTitle4',
    'BimManagersAndProjectControllersSliderTitle5',
    'BimManagersAndProjectControllersSliderTitle6',
  ],
  GeneralContractors: [
    'GeneralContractorsSliderTitle1',
    'GeneralContractorsSliderTitle2',
    'GeneralContractorsSliderTitle3',
    'GeneralContractorsSliderTitle4',
    'GeneralContractorsSliderTitle5',
  ],
  BuildersAndProjectDevelopers: [
    'BuildersAndProjectDevelopersSliderTitle1',
    'BuildersAndProjectDevelopersSliderTitle2',
    'BuildersAndProjectDevelopersSliderTitle3',
    'BuildersAndProjectDevelopersSliderTitle4',
  ],
};
